(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime/helpers/typeof", "@babel/runtime/helpers/defineProperty", "./index.less", "../field-item", "../number-keyboard", "../transition", "./calcTextareaHeight", "./cursor", "../_util", "../_util/formate-value"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime/helpers/typeof"), require("@babel/runtime/helpers/defineProperty"), require("./index.less"), require("../field-item"), require("../number-keyboard"), require("../transition"), require("./calcTextareaHeight"), require("./cursor"), require("../_util"), require("../_util/formate-value"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global._typeof, global.defineProperty, global.index, global.fieldItem, global.numberKeyboard, global.transition, global.calcTextareaHeight, global.cursor, global._util, global.formateValue);
    global.unknown = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _typeof2, _defineProperty2, _index, _fieldItem, _numberKeyboard, _transition, _calcTextareaHeight, _cursor, _util, _formateValue) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _typeof2 = _interopRequireDefault(_typeof2);
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _fieldItem = _interopRequireDefault(_fieldItem);
  _numberKeyboard = _interopRequireDefault(_numberKeyboard);
  _transition = _interopRequireDefault(_transition);
  _calcTextareaHeight = _interopRequireDefault(_calcTextareaHeight);

  var _components;

  var _default2 = {
    render: function render() {
      var _vm = this;

      var _h = _vm.$createElement;

      var _c = _vm._self._c || _h;

      return _c('nx-field-item', {
        staticClass: "nx-input-item",
        class: [_vm.isTitleLatent ? 'is-title-latent' : '', _vm.isInputActive ? 'is-active' : '', _vm.isInputFocus ? 'is-focus' : '', _vm.isInputError() ? 'is-error' : '', _vm.isInputBrief() && !_vm.isInputError() ? 'with-brief' : '', _vm.isInputExtraBottom() && !_vm.isInputBrief() && !_vm.isInputError() ? 'with-extra--bottom' : '', _vm.inputLine ? 'input-line' : '', _vm.isDisabled ? 'is-disabled' : '', _vm.isAmount ? 'is-amount' : '', _vm.clearable ? 'is-clear' : '', _vm.multiline ? 'is-multiline' : '', _vm.$slots.right ? 'right-slot-margin' : '', _vm.multilineBack ? 'is-multiline-back' : '', _vm.align, _vm.size],
        style: {
          '--nx-input-caretColor': _vm.caretColor,
          '--nx-input-textColor': _vm.textColor,
          '--nx-input-inputBackgroundColor': _vm.inputBackgroundColor
        },
        attrs: {
          "leftMinWidth": _vm.leftMinWidth,
          "title": _vm.title,
          "solid": _vm.solid && !_vm.isTitleLatent,
          "border": _vm.border,
          "nowrap": _vm.nowrap,
          "clickable": false,
          "arrow": _vm.arrow,
          "ariaFieldFocus": _vm.ariaFieldInsideFocus,
          "ariaLabelContent": {
            all: _vm.ariaInsideLabelContent.all,
            left: _vm.ariaInsideLabelContent.left
          }
        }
      }, [_c('template', {
        slot: "left"
      }, [_vm._t("left")], 2), !_vm.isVirtualKeyboard & !_vm.ariaInputMaskOrReadonly ? [!_vm.multiline ? [(_vm.nativeInputType || _vm.inputType) === 'checkbox' ? _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: _vm.inputBindValue,
          expression: "inputBindValue"
        }],
        staticClass: "nx-input-item-input",
        attrs: {
          "name": _vm.name,
          "placeholder": _vm.inputPlaceholder,
          "disabled": _vm.isDisabled,
          "readonly": _vm.readonly,
          "maxlength": _vm.isInputFormative ? '' : _vm.maxlength,
          "autocomplete": "off",
          "type": "checkbox"
        },
        domProps: {
          "checked": Array.isArray(_vm.inputBindValue) ? _vm._i(_vm.inputBindValue, null) > -1 : _vm.inputBindValue
        },
        on: {
          "focus": _vm.$_onFocus,
          "blur": _vm.$_onBlur,
          "keyup": _vm.$_onKeyup,
          "keydown": _vm.$_onKeydown,
          "input": _vm.$_onInput,
          "change": function change($event) {
            var $$a = _vm.inputBindValue,
                $$el = $event.target,
                $$c = $$el.checked ? true : false;

            if (Array.isArray($$a)) {
              var $$v = null,
                  $$i = _vm._i($$a, $$v);

              if ($$el.checked) {
                $$i < 0 && (_vm.inputBindValue = $$a.concat([$$v]));
              } else {
                $$i > -1 && (_vm.inputBindValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
              }
            } else {
              _vm.inputBindValue = $$c;
            }
          }
        }
      }) : (_vm.nativeInputType || _vm.inputType) === 'radio' ? _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: _vm.inputBindValue,
          expression: "inputBindValue"
        }],
        staticClass: "nx-input-item-input",
        attrs: {
          "name": _vm.name,
          "placeholder": _vm.inputPlaceholder,
          "disabled": _vm.isDisabled,
          "readonly": _vm.readonly,
          "maxlength": _vm.isInputFormative ? '' : _vm.maxlength,
          "autocomplete": "off",
          "type": "radio"
        },
        domProps: {
          "checked": _vm._q(_vm.inputBindValue, null)
        },
        on: {
          "focus": _vm.$_onFocus,
          "blur": _vm.$_onBlur,
          "keyup": _vm.$_onKeyup,
          "keydown": _vm.$_onKeydown,
          "input": _vm.$_onInput,
          "change": function change($event) {
            _vm.inputBindValue = null;
          }
        }
      }) : _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: _vm.inputBindValue,
          expression: "inputBindValue"
        }],
        staticClass: "nx-input-item-input",
        attrs: {
          "name": _vm.name,
          "placeholder": _vm.inputPlaceholder,
          "disabled": _vm.isDisabled,
          "readonly": _vm.readonly,
          "maxlength": _vm.isInputFormative ? '' : _vm.maxlength,
          "autocomplete": "off",
          "type": _vm.nativeInputType || _vm.inputType
        },
        domProps: {
          "value": _vm.inputBindValue
        },
        on: {
          "focus": _vm.$_onFocus,
          "blur": _vm.$_onBlur,
          "keyup": _vm.$_onKeyup,
          "keydown": _vm.$_onKeydown,
          "input": [function ($event) {
            if ($event.target.composing) {
              return;
            }

            _vm.inputBindValue = $event.target.value;
          }, _vm.$_onInput]
        }
      })] : [_c('textarea', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: _vm.inputBindValue,
          expression: "inputBindValue"
        }],
        ref: "textarea",
        staticClass: "nx-input-item-textarea",
        style: _vm.textareaCalcStyle,
        attrs: {
          "name": _vm.name,
          "placeholder": _vm.inputPlaceholder,
          "disabled": _vm.isDisabled,
          "readonly": _vm.readonly,
          "maxlength": _vm.isInputFormative ? '' : _vm.maxlength,
          "rows": _vm.maxRows,
          "autocomplete": "off"
        },
        domProps: {
          "value": _vm.inputBindValue
        },
        on: {
          "input": [function ($event) {
            if ($event.target.composing) {
              return;
            }

            _vm.inputBindValue = $event.target.value;
          }, _vm.autoScroll, _vm.$_onInput],
          "focus": _vm.$_onFocus,
          "blur": _vm.$_onBlur,
          "keyup": _vm.$_onKeyup,
          "keydown": _vm.$_onKeydown
        }
      })]] : [_c('div', {
        staticClass: "nx-input-item-fake nx-input-item-fake-flex_align_center",
        class: {
          'is-focus': _vm.isInputFocus,
          'is-waiting': !_vm.isInputEditing,
          disabled: _vm.isDisabled,
          readonly: _vm.readonly
        },
        attrs: {
          "aria-label": _vm.$broadcastNumber(_vm.ariaInsideLabelContent.middle || _vm.inputValue)
        },
        on: {
          "click": _vm.$_onFakeInputClick
        }
      }, [_vm.inputType !== 'password' ? _c('span', {
        staticClass: "nx-input-fake-ellipsis",
        domProps: {
          "textContent": _vm._s(_vm.inputValue)
        }
      }) : _c('span', {
        staticClass: "nx-input-fake-ellipsis"
      }, [_vm._l(_vm.inputValue.length, function (n) {
        return [_vm._v("•")];
      })], 2), _vm.inputValue === '' && _vm.inputPlaceholder !== '' ? _c('span', {
        staticClass: "nx-input-item-fake-placeholder nx-input-fake-ellipsis",
        domProps: {
          "innerHTML": _vm._s(_vm.inputPlaceholder)
        }
      }) : _vm._e()])], _c('template', {
        slot: "right"
      }, [_vm.clearable && !_vm.isDisabled && !_vm.readonly ? _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: !_vm.isInputEmpty && _vm.isInputFocus,
          expression: "!isInputEmpty && isInputFocus"
        }],
        staticClass: "nx-input-item-clear",
        attrs: {
          "role": "button",
          "aria-label": _vm.ariaInsideLabelContent.right || '删除',
          "tabindex": "1"
        },
        on: {
          "click": _vm.$_clearInput
        }
      }, [_c('i', {
        staticClass: "clear-icon",
        attrs: {
          "aria-hidden": "true"
        }
      })]) : _vm._e(), _vm._t("contentRight")], 2), _c('template', {
        slot: "right"
      }, [_vm.type === 'verificode' ? [_c('div', {
        staticClass: "verificode-wrap"
      }, [_vm.getRemainTime > 0 && !_vm.isDisabled ? _c('div', {
        staticClass: "time",
        attrs: {
          "aria-label": _vm.getRemainTime + "秒"
        }
      }, [_vm._v("\n          （" + _vm._s(_vm.getRemainTime) + "s）\n        ")]) : _c('div', {
        staticClass: "send-code",
        class: [_vm.verifyCodeDisabled ? 'verificode-disable-text' : 'verificode-active-text'],
        on: {
          "click": _vm.getMsgCode
        }
      }, [_vm._v("\n          " + _vm._s(_vm.verifyText) + "\n        ")])])] : [_vm._t("right")]], 2), _c('template', {
        slot: "error"
      }, [_c('nx-transition', {
        attrs: {
          "name": "nx-input-error"
        }
      }, [_vm.isInputError() ? _c('div', {
        staticClass: "nx-input-item-msg",
        attrs: {
          "aria-live": "polite"
        }
      }, [_vm.error !== '' ? _c('p', {
        domProps: {
          "textContent": _vm._s(_vm.error)
        }
      }) : _vm._t("error")], 2) : _vm._e()])], 1), _c('template', {
        slot: "brief"
      }, [_vm.isInputBrief() && !_vm.isInputError() ? _c('div', {
        staticClass: "nx-input-item-brief"
      }, [_vm.brief !== '' ? _c('p', {
        domProps: {
          "textContent": _vm._s(_vm.brief)
        }
      }) : _vm._t("brief")], 2) : _vm._e()]), _c('template', {
        slot: "extraBottom"
      }, [_vm.isInputExtraBottom() && !_vm.isInputBrief() && !_vm.isInputError() ? _c('div', {
        staticClass: "nx-input-item-extra--bottom"
      }, [_vm.extraBottom !== '' ? _c('p', {
        domProps: {
          "textContent": _vm._s(_vm.extraBottom)
        }
      }) : _vm._t("extraBottom")], 2) : _vm._e()]), _c('template', {
        slot: "textareaBottom"
      }, [_vm._t("textareaBottom")], 2), _c('template', {
        slot: "ariaInputLength"
      }, [_c('div', {
        staticClass: "nx-input-item-aria",
        attrs: {
          "aria-live": _vm.ariaFieldInsideFocus.ariaInputLength ? 'polite' : 'off',
          "aria-hidden": !_vm.ariaFieldInsideFocus.ariaInputLength
        }
      }, [_vm._v("\n      " + _vm._s(_vm.ariaInputLength) + "\n    ")])]), _vm.isVirtualKeyboard && !_vm.virtualKeyboardVm ? _c('nx-number-keyboard', {
        ref: "number-keyboard",
        staticClass: "nx-input-item-number-keyboard",
        attrs: {
          "ariaAutoFocus": _vm.ariaKeyBoardAutoFocus,
          "board-type": _vm.virtualKeyboardType,
          "hide-dot": _vm.keyboardHideDot,
          "show-id": _vm.virtualKeyboardShowId,
          "id": _vm.name + "-number-keyboard",
          "ok-text": _vm.virtualKeyboardOkText,
          "disorder": _vm.virtualKeyboardDisorder,
          "showNum": _vm.showNum,
          "keyBoardIcon": _vm.keyBoardIcon
        }
      }) : _vm._e()], 2);
    },
    name: 'nx-input-item',
    components: (_components = {}, (0, _defineProperty2.default)(_components, _fieldItem.default.name, _fieldItem.default), (0, _defineProperty2.default)(_components, _numberKeyboard.default.name, _numberKeyboard.default), (0, _defineProperty2.default)(_components, _transition.default.name, _transition.default), _components),
    inject: {
      rootField: {
        from: 'rootField',
        default: function _default() {
          return {};
        }
      }
    },
    props: {
      nativeInputType: {
        type: String
      },
      type: {
        // text, bankCard, password, phone, money, digit, verificode, idCard
        type: String,
        default: 'text'
      },
      previewType: {
        type: String,
        default: ''
      },
      name: {
        type: [String, Number],
        default: function _default() {
          return (0, _util.randomId)('input-item');
        }
      },
      title: {
        type: String,
        default: ''
      },
      brief: {
        type: String,
        default: ''
      },
      extraBottom: {
        type: String,
        default: ''
      },
      value: {
        type: [String, Number],
        default: ''
      },
      placeholder: {
        type: String,
        default: ''
      },
      maxlength: {
        type: [String, Number],
        default: ''
      },
      size: {
        // large, normal
        type: String,
        default: 'normal'
      },
      align: {
        // left, center, right
        type: String,
        default: 'left'
      },
      error: {
        type: String,
        default: ''
      },
      readonly: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      solid: {
        type: Boolean,
        default: true
      },
      clearable: {
        type: Boolean,
        default: false
      },
      isVirtualKeyboard: {
        type: Boolean,
        default: false
      },
      virtualKeyboardType: {
        type: String,
        default: 'modern'
      },
      virtualKeyboardHideDot: {
        type: Boolean,
        default: false
      },
      virtualKeyboardDisorder: {
        type: Boolean
      },
      virtualKeyboardOkText: {
        type: String
      },
      virtualKeyboardVm: {
        type: [Object, String],
        default: null
      },
      isTitleLatent: {
        type: Boolean,
        default: false
      },
      isFormative: {
        type: Boolean,
        default: false
      },
      isAmount: {
        type: Boolean,
        default: false
      },
      formation: {
        type: Function,
        default: _util.noop
      },
      border: {
        type: Boolean,
        default: false
      },
      nowrap: {
        type: Boolean,
        default: true
      },
      multiline: {
        type: Boolean,
        default: false
      },
      arrow: {
        type: Boolean,
        default: false
      },
      countdownTime: {
        type: Number,
        default: 60
      },
      minRows: {
        type: Number,
        default: 1
      },
      maxRows: {
        type: Number,
        default: 2
      },
      verifyCodeDisabled: {
        type: Boolean,
        default: false
      },
      showNum: {
        type: Boolean,
        default: false
      },
      inputLine: {
        type: Boolean,
        default: false
      },
      leftMinWidth: {
        type: Boolean,
        default: false
      },
      keyBoardIcon: {
        type: String
      },
      ariaLabelContent: {
        type: Object,
        default: function _default() {
          return {
            all: '',
            middle: '',
            left: '',
            right: ''
          };
        }
      },
      ariaFieldFocus: {
        type: Object,
        default: function _default() {
          return {
            all: false,
            left: true,
            middle: true,
            right: true,
            children: false,
            brief: false,
            extraBottom: false
          };
        }
      },
      ariaKeyBoardAutoFocus: {
        type: Boolean,
        default: true
      },
      ariaInputMaskOrReadonly: {
        type: Boolean,
        default: false
      },
      multilineBack: {
        type: Boolean,
        default: false
      },
      multilineHeight: {
        type: String,
        default: ''
      },
      caretColor: {
        type: String,
        default: ''
      },
      textColor: {
        type: String,
        default: ''
      },
      inputBackgroundColor: {
        type: String,
        default: ''
      },
      immediateCount: {
        type: Boolean,
        default: true
      }
    },
    data: function data() {
      return {
        inputValue: '',
        inputBindValue: '',
        inputNumberKeyboard: '',
        isInputFocus: false,
        isInputEditing: false,
        isPreview: false,
        textareaCalcStyle: {},
        isSendCode: false,
        remain: 0,
        verifyTimes: 0,
        showKeyBoard: false
      };
    },
    computed: {
      inputItemType: function inputItemType() {
        return (this.isPreview ? this.previewType : this.type) || 'text';
      },
      inputType: function inputType() {
        var inputType = this.inputItemType || 'text';

        if (inputType === 'bankCard' || inputType === 'phone' || inputType === 'digit' || inputType === 'areaPhone' || inputType === 'idCard') {
          inputType = 'tel';
        } else if (inputType === 'money') {
          inputType = 'text';
        }

        return inputType;
      },
      inputMaxLength: function inputMaxLength() {
        if (this.inputItemType === 'phone') {
          return 11;
        } else if (this.inputItemType === 'idCard') {
          return 18;
        } else {
          return this.maxlength;
        }
      },
      inputPlaceholder: function inputPlaceholder() {
        return this.isTitleLatent && this.isInputActive ? '' : this.placeholder;
      },
      isInputActive: function isInputActive() {
        return !this.isInputEmpty || this.isInputFocus;
      },
      isInputEmpty: function isInputEmpty() {
        return !this.inputValue.length;
      },
      isInputFormative: function isInputFormative() {
        var type = this.inputItemType;
        return this.isFormative || type === 'bankCard' || type === 'phone' || type === 'money' || type === 'digit' || type === 'idCard' || this.nativeInputType === 'tel';
      },
      isDisabled: function isDisabled() {
        return this.rootField.disabled || this.disabled;
      },
      getRemainTime: function getRemainTime() {
        return Math.floor(this.remain % (60 * 1000) / 1000);
      },
      keyboardHideDot: function keyboardHideDot() {
        if (this.type === 'verificode' || this.type === 'idCard' || this.type === 'phone' || this.type === 'bankCard') {
          return true;
        }

        return this.virtualKeyboardHideDot;
      },
      virtualKeyboardShowId: function virtualKeyboardShowId() {
        return this.type === 'idCard' ? true : false;
      },
      verifyText: function verifyText() {
        return this.verifyTimes > 0 ? '重新获取' : '获取验证码';
      },
      ariaInsideLabelContent: function ariaInsideLabelContent() {
        var _this$ariaLabelConten = this.ariaLabelContent,
            _this$ariaLabelConten2 = _this$ariaLabelConten.middle,
            middle = _this$ariaLabelConten2 === void 0 ? '' : _this$ariaLabelConten2,
            _this$ariaLabelConten3 = _this$ariaLabelConten.right,
            right = _this$ariaLabelConten3 === void 0 ? '' : _this$ariaLabelConten3,
            _this$ariaLabelConten4 = _this$ariaLabelConten.all,
            all = _this$ariaLabelConten4 === void 0 ? '' : _this$ariaLabelConten4,
            _this$ariaLabelConten5 = _this$ariaLabelConten.left,
            left = _this$ariaLabelConten5 === void 0 ? '' : _this$ariaLabelConten5;
        return {
          middle: middle,
          right: right,
          all: all,
          left: left
        };
      },
      ariaFieldInsideFocus: function ariaFieldInsideFocus() {
        var _this$ariaFieldFocus = this.ariaFieldFocus,
            _this$ariaFieldFocus$ = _this$ariaFieldFocus.all,
            all = _this$ariaFieldFocus$ === void 0 ? false : _this$ariaFieldFocus$,
            _this$ariaFieldFocus$2 = _this$ariaFieldFocus.left,
            left = _this$ariaFieldFocus$2 === void 0 ? true : _this$ariaFieldFocus$2,
            _this$ariaFieldFocus$3 = _this$ariaFieldFocus.middle,
            middle = _this$ariaFieldFocus$3 === void 0 ? true : _this$ariaFieldFocus$3,
            _this$ariaFieldFocus$4 = _this$ariaFieldFocus.right,
            right = _this$ariaFieldFocus$4 === void 0 ? true : _this$ariaFieldFocus$4,
            _this$ariaFieldFocus$5 = _this$ariaFieldFocus.children,
            children = _this$ariaFieldFocus$5 === void 0 ? false : _this$ariaFieldFocus$5,
            _this$ariaFieldFocus$6 = _this$ariaFieldFocus.brief,
            brief = _this$ariaFieldFocus$6 === void 0 ? false : _this$ariaFieldFocus$6,
            _this$ariaFieldFocus$7 = _this$ariaFieldFocus.extraBottom,
            extraBottom = _this$ariaFieldFocus$7 === void 0 ? false : _this$ariaFieldFocus$7,
            _this$ariaFieldFocus$8 = _this$ariaFieldFocus.ariaInputLength,
            ariaInputLength = _this$ariaFieldFocus$8 === void 0 ? true : _this$ariaFieldFocus$8;
        return {
          middle: middle,
          right: right,
          all: all,
          left: left,
          children: children,
          brief: brief,
          extraBottom: extraBottom,
          ariaInputLength: ariaInputLength
        };
      },
      ariaInputLength: function ariaInputLength() {
        if (this.isVirtualKeyboard && !this.virtualKeyboardVm && this.showKeyBoard) {
          var str = this.inputValue && typeof this.inputValue === 'string' ? this.inputValue.replace(/\s/g, '') : '';
          return "\u5DF2\u8F93\u5165".concat(str.length, "\u4F4D");
        } else {
          return '';
        }
      }
    },
    watch: {
      value: function value(val) {
        // Filter out two-way binding
        if (val !== this.$_trimValue(this.inputValue)) {
          this.inputValue = this.$_formateValue(this.$_subValue(val + '')).value;
        }
      },
      previewType: {
        handler: function handler(val) {
          this.isPreview = !!val;
        },
        immediate: true
      },
      inputValue: function inputValue(val) {
        this.$nextTick(this.resizeTextarea);
        this.inputBindValue = val;
        val = this.isInputFormative ? this.$_trimValue(val) : val;

        if (val !== this.value) {
          this.$emit('input', val);
          this.$emit('change', this.name, val);
        }
      },
      isInputFocus: function isInputFocus(val) {
        if (!this.isVirtualKeyboard || !this.inputNumberKeyboard) {
          return;
        }

        if (val) {
          this.inputNumberKeyboard.show();
          this.showKeyBoard = true;
          this.$emit('focus', this.name);
        } else {
          this.inputNumberKeyboard.hide();
          this.showKeyBoard = false;
          this.$emit('blur', this.name);
        }
      }
    },
    created: function created() {
      this.inputValue = this.$_formateValue(this.$_subValue(this.value + '')).value;
    },
    mounted: function mounted() {
      var _this = this;

      this.isVirtualKeyboard && this.$nextTick(function () {
        _this.$_initNumberKeyBoard();
      });
      this.resizeTextarea();
    },
    beforeDestroy: function beforeDestroy() {
      var keyboard = this.inputNumberKeyboard;

      if (keyboard && keyboard.$el && document.body.contains(keyboard.$el)) {
        document.body.removeChild(keyboard.$el);
      }
    },
    methods: {
      autoScroll: function autoScroll() {
        var textarea = this.$refs.textarea;

        if (textarea) {
          textarea.scrollTop = textarea.scrollHeight;
        }
      },
      $broadcastNumber: function $broadcastNumber(number) {
        var numberMap = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
        var specialMap = {
          '*': '星号',
          X: '叉号'
        };
        return number.toString().split('').map(function (item) {
          return numberMap[item] || specialMap[item] || item;
        }).join('');
      },
      // MARK: private methods
      $_formateValue: function $_formateValue(curValue) {
        var curPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var type = this.inputItemType;
        var name = this.name;
        var oldValue = this.inputValue;
        var isAdd = oldValue.length > curValue.length ? -1 : 1;
        var formateValue = {
          value: curValue,
          range: curPos
        }; // no format

        if (!this.isInputFormative || curValue === '') {
          return formateValue;
        } // custom format by user


        var customValue = this.formation(name, curValue, curPos); // 自定义格式化函数返回该函数返回的值

        if (this.isFormative) {
          // return customValue
          return {
            value: customValue,
            range: curPos
          };
        }

        if (this.nativeInputType === 'tel') {
          curValue = this.$_subValue((0, _formateValue.trimValue)(curValue.replace(/\D/g, '')));
          formateValue.value = curValue;
        } // default format by component


        var gap = ' ';

        switch (type) {
          case 'bankCard':
            curValue = this.$_subValue((0, _formateValue.trimValue)(curValue.replace(/\D/g, '')));
            formateValue = (0, _formateValue.formatValueByGapStep)(4, curValue, gap, 'left', curPos, isAdd, oldValue);
            break;

          case 'phone':
            curValue = this.$_subValue((0, _formateValue.trimValue)(curValue.replace(/\D/g, '')));
            formateValue = (0, _formateValue.formatValueByGapRule)('3|4|4', curValue, gap, curPos, isAdd);
            break;

          case 'idCard':
            curValue = this.$_subValue((0, _formateValue.trimValue)(curValue.replace(/[^0-9Xx]$/g, '')));
            formateValue = (0, _formateValue.formatValueByGapRule)('6|8|4', curValue, gap, curPos, isAdd);
            break;

          case 'money':
            {
              gap = ',';
              curValue = this.$_subValue((0, _formateValue.trimValue)(curValue.replace(/[^\d.]/g, ''))); // curValue = curValue.replace(/\D/g, '')

              var dotPos = curValue.indexOf('.'); // format if no dot or new add dot or insert befor dot

              var moneyCurValue = curValue.split('.')[0];
              var moneyCurDecimal = ~dotPos ? ".".concat(curValue.split('.')[1].substr(0, 2)) : '';
              formateValue = (0, _formateValue.formatValueByGapStep)(3, (0, _formateValue.trimValue)(moneyCurValue, gap), gap, 'right', curPos, isAdd, oldValue.split('.')[0]);
              formateValue.value += moneyCurDecimal;
              break;
            }

          case 'digit':
            curValue = this.$_subValue((0, _formateValue.trimValue)(curValue.replace(/\D/g, '')));
            formateValue.value = curValue;
            break;

          /* istanbul ignore next */

          default:
            break;
        }

        return formateValue;
      },
      isInputError: function isInputError() {
        return this.$slots.error || this.error !== '';
      },
      isInputBrief: function isInputBrief() {
        return this.$slots.brief || this.brief !== '';
      },
      isInputExtraBottom: function isInputExtraBottom() {
        return this.$slots.extraBottom || this.extraBottom !== '';
      },
      $_trimValue: function $_trimValue(val) {
        return this.inputItemType === 'money' ? (0, _formateValue.trimValue)(val, '\\s|,') : (0, _formateValue.trimValue)(val, '\\s');
      },
      $_subValue: function $_subValue(val) {
        var len = this.inputMaxLength;

        if (len !== '') {
          return val.substring(0, len);
        } else {
          return val;
        }
      },
      $_startEditInput: function $_startEditInput() {
        this.isInputEditing = true;
        this.$_stopEditInput();
      },
      $_stopEditInput: (0, _util.debounce)(function () {
        this.isInputEditing = false;
      }, 500),
      $_clearInput: function $_clearInput() {
        this.inputValue = '';
        !this.isTitleLatent && this.focus();
        this.isPreview = false;
      },
      $_stopPreview: function $_stopPreview() {
        this.$_clearInput();
        this.$emit('update:previewType', '');
      },
      $_focusFakeInput: function $_focusFakeInput() {
        var _this2 = this;

        this.isInputFocus = true;
        setTimeout(function () {
          _this2.$_addBlurListener();
        }, 0);
      },
      $_blurFakeInput: function $_blurFakeInput() {
        this.isInputFocus = false;
        this.$_removeBlurListener();
      },
      $_addBlurListener: function $_addBlurListener() {
        document.addEventListener('click', this.$_blurFakeInput, false);
      },
      $_removeBlurListener: function $_removeBlurListener() {
        document.removeEventListener('click', this.$_blurFakeInput, false);
      },
      $_initNumberKeyBoard: function $_initNumberKeyBoard() {
        var keyboard = ((0, _typeof2.default)(this.virtualKeyboardVm) === 'object' ? this.virtualKeyboardVm : this.$vnode.context.$refs[this.virtualKeyboardVm]) || this.$refs['number-keyboard'];

        if (Array.isArray(keyboard)) {
          keyboard = keyboard[0];
        }

        keyboard.$on('output', this.$_onNumberKeyBoardEnter);
        keyboard.$on('delete', this.$_onNumberKeyBoardDelete);
        keyboard.$on('confirm', this.$_onNumberKeyBoardConfirm);
        this.inputNumberKeyboard = keyboard;
        document.body.appendChild(keyboard.$el);
      },
      // MARK: events handler
      $_onInput: function $_onInput(event) {
        var formateValue = this.$_formateValue(event.target.value, this.isInputFormative ? (0, _cursor.getCursorsPosition)(event.target) : 0);
        this.inputValue = formateValue.value;
        this.inputBindValue = formateValue.value;

        if (this.isInputFormative) {
          setTimeout(function () {
            (0, _cursor.setCursorsPosition)(event.target, formateValue.range);
          }, 0);
        }
      },
      $_onKeyup: function $_onKeyup(event) {
        this.$emit('keyup', this.name, event);

        if (+event.keyCode === 13 || +event.keyCode === 108) {
          this.$emit('confirm', this.name, this.inputValue);
        }
      },
      $_onKeydown: function $_onKeydown(event) {
        this.$emit('keydown', this.name, event);

        if (!(+event.keyCode === 13 || +event.keyCode === 108)) {
          this.$_startEditInput();
          this.isPreview && this.$_stopPreview();
        }
      },
      $_onFocus: function $_onFocus() {
        this.isInputFocus = true;
        this.$emit('focus', this.name);
      },
      $_onBlur: function $_onBlur() {
        var _this3 = this;

        setTimeout(function () {
          _this3.isInputFocus = false;

          _this3.$emit('blur', _this3.name);
        }, 100);
      },
      $_onFakeInputClick: function $_onFakeInputClick(event) {
        if (this.isDisabled || this.readonly) {
          return;
        }

        this.$_blurFakeInput();

        if (!this.isInputFocus) {
          this.$_focusFakeInput(event);
        }
      },
      $_onNumberKeyBoardEnter: function $_onNumberKeyBoardEnter(val) {
        if (this.isPreview) {
          this.$_stopPreview();
        } // 兼容键盘删除按钮`#`


        if (this.inputMaxLength > 0 && this.$_trimValue(this.inputValue).length >= this.inputMaxLength || val === '#') {
          return;
        }

        this.inputValue = this.$_formateValue(this.inputValue + val).value;
        this.$_startEditInput();
      },
      $_onNumberKeyBoardDelete: function $_onNumberKeyBoardDelete() {
        var inputValue = this.inputValue;

        if (inputValue === '') {
          return;
        }

        this.inputValue = this.$_formateValue(inputValue.substring(0, inputValue.length - 1)).value;
        this.$_startEditInput();

        if (this.isPreview) {
          this.$_stopPreview();
        }
      },
      $_onNumberKeyBoardConfirm: function $_onNumberKeyBoardConfirm() {
        this.$emit('confirm', this.name, this.inputValue);
      },
      // MARK: public methods
      focus: function focus() {
        var _this4 = this;

        if (this.isVirtualKeyboard) {
          this.$_onFakeInputClick();
        } else {
          if (this.multiline) {
            this.$el.querySelector('.nx-input-item-textarea').focus();
          } else {
            this.$el.querySelector('.nx-input-item-input').focus();
          }

          setTimeout(function () {
            _this4.isInputFocus = true;
          }, 200);
        }
      },
      blur: function blur() {
        if (this.isVirtualKeyboard) {
          this.$_blurFakeInput();
        } else {
          if (this.multiline) {
            this.$el.querySelector('.nx-input-item-textarea').blur();
          } else {
            this.$el.querySelector('.nx-input-item-input').blur();
          }

          this.isInputFocus = false;
        }
      },
      getValue: function getValue() {
        return this.inputValue;
      },
      resizeTextarea: function resizeTextarea() {
        if (!this.multiline) return;

        if (this.multilineHeight) {
          this.textareaCalcStyle = {
            height: this.multilineHeight
          };
          return;
        }

        this.textareaCalcStyle = (0, _calcTextareaHeight.default)(this.$refs.textarea, this.minRows, this.maxRows);
      },
      start: function start() {
        if (this.type === 'verificode') {
          ++this.verifyTimes;
          this.remain = this.countdownTime * 1000;
          this.endTime = Date.now() + this.remain;
          this.$_tick();
        }
      },
      $_tick: function $_tick() {
        var _this5 = this;

        this.rafId = window.requestAnimationFrame(function () {
          _this5.$_setRemain(_this5.$_getRemain());

          if (_this5.remain !== 0) {
            _this5.$_tick();
          }
        });
      },
      $_getRemain: function $_getRemain() {
        return Math.max(this.endTime - Date.now(), 0);
      },
      $_setRemain: function $_setRemain(remain) {
        this.remain = remain;

        if (remain === 0) {
          window.cancelAnimationFrame(this.rafId);
        }
      },
      getMsgCode: function getMsgCode() {
        if (this.isDisabled || this.verifyCodeDisabled) {
          return;
        }

        if (this.immediateCount) {
          this.start();
        }

        this.$emit('sendMsgCode');
      }
    }
  };
  _exports.default = _default2;
});